import { createContext } from 'react'
import { UseToast } from '../types'

export const ToastContext = createContext<UseToast>(null!)
